<template>
  <div class="l-default">
    <!-- ライフエール独自対応 >>>>>>> -->
    <OrganismsCommonHeader @clickMenuBtn="clickMenuBtn" />
    <!-- Header :content="contentHeaderFooter" :isShowSupplementaryCoupon="isShowSupplementaryCoupon" :isShowCafeteriaPoint="isShowCafeteriaPoint" /-->
    <CrlyOrganismsContentsNavBar :showMenu="showMenu" />
    <!-- ライフエール独自対応 <<<<<<< -->
    <div class="l-container sm:border-b">
    <!-- ライフエール独自対応 ↓↓↓↓ -->
    <!-- <Breadcrumb v-if="!isPublicMenu" /> -->
    <Breadcrumb class="font-setting" v-if="!isPublicMenu && showBreadcrumb && !hideBreadcrumb" />
    <!-- ライフエール独自対応 ↑↑↑↑ -->
  </div>
  <!-- ライフエールstay独自対応 -->
    <router-view class="font-setting" :isShowSupplementaryCoupon="isShowSupplementaryCoupon" :isShowCafeteriaPoint="isShowCafeteriaPoint"></router-view>
    <div v-show="scY > 300" class="scrollTop">
      <button class="btn-back-to-top" @click="toTop">
        <Icon
            class="pageTop__button__icon"
            name="arrow_up"
            width="40px"
            height="40px"
          />
      </button>
    </div>
    <!-- ライフエール独自対応 >>>>>>> -->
    <!-- ライフエールのフッターに差し替え -->
    <OrganismsCommonFooter />
    <!-- Footer :content="contentHeaderFooter" /-->
    <CrlyOrganismsCommonFooterNav
      :showMenu="showMenu"
      @clickMenuBtn="clickMenuBtn"
    />
    <CommonModal class="font-setting" />
    <!-- ライフエール独自対応 <<<<<<< -->
  </div>
</template>

<script>
// ライフエール独自対応 >>>>>>>
import CrlyOrganismsContentsNavBar from "@crly/components/organisms/contents/NavBar.vue";
import CrlyOrganismsCommonFooterNav from "@crly/components/organisms/common/FooterNav.vue";
import OrganismsCommonHeader from "@crly/components/organisms/common/Header.vue";
import OrganismsCommonFooter from "@crly/components/organisms/common/Footer.vue";
//import Header from '@/components/Header'
//import Footer from '@/components/Footer'
// ライフエール独自対応 <<<<<<<
import { get } from 'lodash'
// ライフエール独自対応
// import Header from '@/components/Header'
// import Footer from '@/components/Footer'
import { bus } from '@/main'
import { Breadcrumb } from '@/components/compound'
export default {
  name: 'DefaultLayout',
  components: {
    // ライフエール独自対応 >>>>>>>
    CrlyOrganismsContentsNavBar,
    CrlyOrganismsCommonFooterNav,
    OrganismsCommonHeader,
    OrganismsCommonFooter,
    //    Header,
    //    Footer,
    // ライフエール独自対応 <<<<<<<
    Breadcrumb
  },
  data() {
    return {
      /**
       * ライフエール独自対応
       * スライドメニューの表示状態
       */
      showMenu: false,
      scTimer: 0,
      scY: 0,
      headerNo: this.$route.meta.header,
      footerNo: this.$route.meta.footer,
      contentHeaderFooter: null,
      isPublicMenu:false,
      isShowSupplementaryCoupon: false,
      isShowCafeteriaPoint: false,

      /**
       * ライフエール独自対応
       * パンくずリスト表示可否
       */
      showBreadcrumb: true
    }
  },
  async created() {
    try {
      this.getData();
      const availableDataList = await this.$repositories('coupon').getSubsidyCouponList({displayDiv: "1"});
      const cafe = await this.$repositories('cafe').checkCafeAvailable();
      const avaialbleCafe = cafe.data;

      if (avaialbleCafe && avaialbleCafe === 'OK') {
        this.isShowCafeteriaPoint = true;
      }

      if (availableDataList && availableDataList.length > 0) {
        this.isShowSupplementaryCoupon = true;
      }
    } catch (error) {
      console.error('Error in created hook (Promise/async):', error);
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
    bus.$on('noPuclicDate', (val)=>{
      console.log(val)
      this.isPublicMenu = val
    })
    // ライフエール独自対応 ↓↓↓↓
    if (
      this.$route.name === "CrlyNotMember" ||
      this.$route.name === "CrlyLineBusyError"
    ) {
      this.showBreadcrumb = false;
    } else {
      this.showBreadcrumb = true;
    }
    // ライフエール独自対応 ↑↑↑↑
  },
  beforeDestroy(){
    bus.$off('noPuclicDate')
  },
  methods: {
    handleScroll() {
      if (this.scTimer) return
      this.scTimer = setTimeout(() => {
        this.scY = window.scrollY
        clearTimeout(this.scTimer)
        this.scTimer = 0
      }, 100)
    },
    toTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    },
    getData() {
      this.$repositories('cms')
        .getHeaderFooter()
        .then((response) => {
          this.contentHeaderFooter = get(response, 'data')
        })
    },
    // ライフエール専用処理>>>
    getUserInfo() {
      if (this.isLoggedIn && !this.$store.getters["userInfo/getUserInfo"]) {
        // ログイン済みだが、個人情報を保持していない場合
        this.$store.dispatch("loading/show", 10);
        this.$repositories("user")
          .postUser()
          .then((res) => {
            this.$store.commit("userInfo/setUserInfo", res.data);
          })
          .catch(() => {
            // エラー画面へ遷移
            this.$router.push({
              name: "CrlyError",
              params: { type: "login", meta: { error: "login" } }
            });
          })
          .finally(() => {
            this.$store.dispatch("loading/hide", 10);
          });
      }
    },
    /**
     * ライフエール独自対応
     * メニューボタンクリックイベント
     * @param {boolean} status - スライドメニューの表示状態
     */
    clickMenuBtn(status) {
      this.$store.commit("menuStatus/setCategoryMenu", status);
      this.$store.commit("menuStatus/setSlideMenu", status);
      this.showMenu = status;
    }
    // ライフエール専用処理<<<
  },
  watch: {
    $route() {
      this.footerNo = this.$route.meta.footer
    }
  },
  computed: {
    isSearchPage() {
      return this.$route.path === "/search/menu";
    },
    hideBreadcrumb() {
      return (
        [
          "BS_APP_02_001 申込(何を・どこに)",
          "BS_APP_02_001_NEW",
          "BS_APP_02_002 申込(誰が)",
          "BS_APP_02_002 申込(誰が) - Public stay",
          "BS_APP_02_004_NEW 補助利用申請",
          "BS_APP_02_005 申込確認",
          "BS_APP_02_005 申込確認 - Public stay",
          "BS_APP_02_006_申込完了ページ / Page hoàn tất đăng ký",
          "BS_APP_02_006_NEW",
        ].includes(this.$route.name)
      )
    }
  }
}
</script>

<style lang="scss" scoped>
@import './styles.scss';
// ライフエールstay独自対応
.font-setting {
  font-family: "Noto Sans JP", sans-serif;
}
</style>
